/**
 * Custom error class for HTTP errors, carrying response metadata.
 */
export class FetchError extends Error {
  readonly correlationId: string;
  readonly data: unknown;
  readonly headers: Headers;
  readonly requestUrl: string;
  readonly status: number;

  constructor(
    message: string,
    options: {
      correlationId: string;
      data: unknown;
      headers: Headers;
      requestUrl: string;
      status: number;
    },
  ) {
    super(message);
    this.name = 'FetchError';
    this.correlationId = options.correlationId;
    this.data = options.data;
    this.headers = options.headers;
    this.requestUrl = options.requestUrl;
    this.status = options.status;
  }
}
